"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HiddenImageIcon = void 0;
const icon_1 = require("../../components/icon");
const icons_1 = require("../../components/icon/icons");
const theme_1 = require("../../components/theme");
const hidden_image_icon_style_1 = require("./hidden.image.icon.style");
(0, theme_1.addStyles)(hidden_image_icon_style_1.Style);
exports.HiddenImageIcon = {
    view(opts = { position: 'center' }) {
        return icon_1.Icon.view(icons_1.MaterialIcon.VISIBILITY_OFF, { className: `${hidden_image_icon_style_1.ClassNames.icon} ${hidden_image_icon_style_1.ClassNames.position[opts.position]}` });
    }
};
//# sourceMappingURL=hidden.image.icon.js.map